'use client';
import { useLocation } from 'react-router-dom';
import { useSocket } from '../contexts/SocketContext';
import { Alert, Button } from 'react-bootstrap';
import { BiWifi, BiWifiOff, BiRefresh } from 'react-icons/bi';

const GlobalConnectionStatus = () => {
  const location = useLocation();
  const { socket, isConnected, connectionStatus, isInitialized } = useSocket();

  // Pages that should NOT show the connection status
  const excludedPages = ['/', '/terms', '/privacy'];

  // Don't show on excluded pages
  if (excludedPages.includes(location.pathname)) {
    return null;
  }

  // Don't show until socket is initialized
  if (!isInitialized) {
    return null;
  }

  // Don't show if connected (only show when there are issues)
  if (isConnected) {
    return null;
  }

  const handleRetryConnection = () => {
    if (socket) {
      socket.connect();
    } else {
      // Reload the page if socket is completely missing
      window.location.reload();
    }
  };

  const getAlertVariant = () => {
    if (
      connectionStatus.includes('Error') ||
      connectionStatus.includes('Failed')
    ) {
      return 'danger';
    }
    if (
      connectionStatus.includes('Reconnecting') ||
      connectionStatus.includes('Connecting')
    ) {
      return 'warning';
    }
    return 'info';
  };

  const getIcon = () => {
    if (isConnected) {
      return <BiWifi className='me-2' />;
    }
    return <BiWifiOff className='me-2' />;
  };

  return (
    <Alert
      variant={getAlertVariant()}
      className='mb-0 rounded-0 d-flex align-items-center justify-content-between'
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1050,
        borderLeft: 'none',
        borderRight: 'none',
        borderTop: 'none',
      }}
    >
      <div className='d-flex align-items-center'>
        {getIcon()}
        <strong>Server Connection:</strong>
        <span className='ms-2'>{connectionStatus}</span>
        {!isConnected && (
          <small className='ms-3 text-muted'>
            Some features may not work properly until connection is restored.
          </small>
        )}
      </div>

      {!isConnected && (
        <Button
          variant={`outline-${getAlertVariant()}`}
          size='sm'
          onClick={handleRetryConnection}
          className='d-flex align-items-center'
        >
          <BiRefresh className='me-1' />
          Retry
        </Button>
      )}
    </Alert>
  );
};

export default GlobalConnectionStatus;
